enum SurveySendViewPoint {
  Drafts = 'DRAFTS',
  History = 'HISTORY',
}

export default SurveySendViewPoint;
